interface RefreshConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function RefreshConfirmModal({
  isOpen,
  onClose,
  onConfirm
}: RefreshConfirmModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-navy-800 border border-navy-700 rounded-lg p-4 w-[340px]">
        <div className="text-sm text-gray-100 mb-3 font-medium">Atualizar Interface do CorelDRAW?</div>
        <div className="text-xs text-gray-400 mb-4">
          Esta ação força o redesenho completo da interface. Use após processos pesados que podem ter deixado a tela desatualizada.
        </div>
        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-3 py-1.5 text-xs rounded border border-navy-600 text-gray-300 hover:bg-navy-700"
          >Cancelar</button>
          <button
            onClick={onConfirm}
            className="px-3 py-1.5 text-xs rounded bg-blue-600 hover:bg-blue-500 text-white"
          >Atualizar</button>
        </div>
      </div>
    </div>
  );
}
